/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ManageFormContainerAssociationModel {
        public formContainerAssociations: Wars.Domain.Model.FormContainerAssociation[];
        public currentFormContainerAssociation: Wars.Domain.Model.FormContainerAssociation;
        
        constructor(
            private formContainerAssociationService: services.FormContainerAssociationService,
            private deleteService: services.DeleteService,
            systemLevelService: services.SystemLevelService)
        {
            systemLevelService.getSystemLevelFormContainerAssociations().then(
                (systemLevel) => {
                    this.formContainerAssociations = systemLevel.myFormContainerAssociations;
                });
        }

        public addFormContainerAssociation(): void {
            var newFormContainerAssociation = this.formContainerAssociationService.createNewFormContainerAssociation();
            this.formContainerAssociations.push(newFormContainerAssociation);
            this.currentFormContainerAssociation = newFormContainerAssociation;
        }

        public editFormContainerAssociation(formContainerAssociation: Wars.Domain.Model.FormContainerAssociation) {
            this.currentFormContainerAssociation = formContainerAssociation;
        }

        public removeFormContainerAssociation(formContainerAssociation: Wars.Domain.Model.FormContainerAssociation) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "FormContainerAssociation",
                formContainerAssociation.id,
                "System Action",
                () => this.formContainerAssociations.remove(formContainerAssociation));
        }

        public save(): void {
            this.formContainerAssociationService.saveAllChanges();
        }

        public close(): void {
            this.currentFormContainerAssociation = undefined;
        }
    }
}